var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFalconidle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 387.6 427.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #151518;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-3, .cls-5, .cls-10, .cls-11 {\n        stroke: #101013;\n      }\n\n      .cls-2, .cls-12 {\n        fill: #aeadae;\n        stroke: #aeadae;\n      }\n\n      .cls-3, .cls-8 {\n        fill: #121214;\n      }\n\n      .cls-4, .cls-13, .cls-14, .cls-15, .cls-12 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4, .cls-14 {\n        fill: #6d7a9c;\n        stroke: #6d7a9c;\n      }\n\n      .cls-5, .cls-16, .cls-9 {\n        fill: #e9e9e9;\n      }\n\n      .cls-13, .cls-7 {\n        fill: #292d3f;\n        stroke: #292d3f;\n      }\n\n      .cls-16 {\n        stroke-width: 0px;\n      }\n\n      .cls-6 {\n        fill: #4c4b4c;\n        stroke: #4c4b4c;\n      }\n\n      .cls-15 {\n        fill: #2d2d2d;\n        stroke: #2d2d2c;\n      }\n\n      .cls-8 {\n        stroke: #121214;\n      }\n\n      .cls-9 {\n        stroke: #e9e9e9;\n      }\n\n      .cls-10 {\n        fill: none;\n      }\n\n      .cls-11 {\n        fill: #101013;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4-2",
    "data-name": "Layer 4-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arms_Colours-4",
    "data-name": "Arms Colours-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M311,272.9l-20.8,77.7-1.4,50.4h-69.9l2.3-74.5,36.3-71s17.2,6.2,27.6,3.5c0,0,11.6,12.6,15.3,13.4s12.3.6,12.3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M317,272.9l-6.6,1.8s-36.4,101.2-22.9,130.2,56-8.2,56-8.2c0,0-12.7-58.3-12.9-63.1s2.6-11.3,0-15.3-6.4-5.3-6.4-5.3l-7.3-40.1h.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "320.3 260.3 314.9 271.5 300.7 268.7 287.6 256 262.8 255.4 269 244.7 291.6 245.4 305.8 257.6 320.3 260.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M82.8,272.9l20.8,77.7,1.4,50.4h69.9l-2.3-74.5-36.3-71s-17.2,6.2-27.5,3.5c0,0-11.6,12.6-15.3,13.4s-12.3.6-12.3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M76.7,272.9l6.6,1.8s35.7,41.7,22.2,70.7-11.1.2-11.1.2c0,0-19.1-18.7-19-23.5s.5-.1-2.4-3.9c-2-2.6-1.2-10-1.2-10l5-35.4h0l-.1.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "73.4 260.3 78.9 271.5 93 268.7 106.2 256 131 255.4 124.7 244.7 102.2 245.4 87.9 257.6 73.4 260.3"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M316.7,273.1l6.7,35.8s3.7,8.8,6.8,11.2-.2,14.9-.2,14.9l12,60.3-17.9,5.7s-3.4-34.4-4.1-43-17.5,4.9-17.5,4.9c0,0,14.6-22,14.2-29.7s-21.4,12.5-21.4,12.5c0,0,13.5-25.7,15.7-33.2s-4.6-20-4.6-20c-16.5-2.4-30.6-24.3-39.2-25.9s-13.5,3.3-13.5,3.3l8-12,25.4,2.5,12.4,12.5s12.7,4.2,17.4.4h0l-.2-.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Arms_Lines-4",
    "data-name": "Arms Lines-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M315.5,263.4c0-3.4-5-4.5-7.4-4.5s-5.8,1.9-5.8,5.1,3.3,3.5,6.6,3.5,6.6-1,6.6-4.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M267.2,243.1s21.5-1.2,25.9,1.6,10.5,10.3,13.1,12.1c2.6,1.8,15.1,0,15.7,3,0,0-5,12.5-6.5,12.5s-14.4-.6-16.9-2.5-7.9-10.4-12.6-12.2-24.8-.8-24.8-.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M343.6,393.4s-12.9-54.6-12-59.8,3.4-12.4-5.3-21.4c0,0-8.4-36.8-8.4-42.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M312.7,272.9s-6.6,27.1-7.6,32.2-13.3,40.5-13.5,49.1-1.4,39.2-1.4,39.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M293.8,348.4c17.1-13.5,24.1-31.3,24.1-31.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M78.3,263.4c0-3.4,5-4.5,7.4-4.5s5.8,1.9,5.8,5.1-3.3,3.5-6.6,3.5-6.6-1-6.6-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M126.5,243.1s-21.5-1.2-25.9,1.6-10.5,10.3-13.1,12.1c-2.6,1.8-15.1,0-15.7,3,0,0,5,12.5,6.5,12.5s14.4-.6,16.9-2.5,7.9-10.4,12.6-12.2,24.8-.8,24.8-.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M74.2,324.6c-.9-5.1-7.5-5.4-1.7-23.4,0,0,3.5-25.8,3.5-31.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M102.2,354.2c.2,8.5,1.3,39.2,1.3,39.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M95.2,269.8s9-2.3,14.1,11.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M100,348.4c-17-13.5-12.5-22.8-12.5-22.8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Main_Colours-4",
    "data-name": "Main Colours-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "248.3 140.7 196.9 146.9 145.4 140.7 128 151.9 157.8 247.6 183.1 331.6 196.9 327.5 210.6 331.6 235.9 247.6 265.8 151.9 248.3 140.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M248.7,95.1l-51.8-2.3-.05,4.51-.05-4.51-51.8,2.3s-52.6,16.5-52.2,25.9c.4,9.4,24.5,21,60.4,22.4,28.9,1.13,39.9,2.71,43.1,3.28v.22s.17-.04.55-.12c.38.07.55.12.55.12v-.22c3.2-.57,14.2-2.15,43.1-3.28,35.9-1.4,60-13,60.4-22.4.4-9.4-52.2-25.9-52.2-25.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M195.4,402.6s18.8,9.7,21.6-10.4-1.6-84.3-1.6-84.3l-18.6,21.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M305.8,155.9l-38.6,66.8s.7,6.2-2.7,20.2c-3.4,13.9-10.5,14.9-10.5,14.9l-35.5,80.9-4.4-93.9,20.2-5.4-15.4-52.5s76.6-10.7,86.9-31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M265.3,140.7s40.4,6.1,39.7,13.6c-.7,7.5-52.8,22-52.8,22,0,0,11.9-9.9,10.2-20.5s-5.9-12.2-5.9-12.2l8.8-3v.1Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 241.1,
    y1: 176.3,
    x2: 240.5,
    y2: 179.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M222.8,208.4s8.1,19.1,7.8,28.5l-7.1,2.4-.7-30.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M255.7,155.9s-1.1,12.8-8.5,16c0,0,4.8-5.4,4.9-7.7s-1.8-6.2-.7-7.8,1.6-4.3,1.6-4.3l2.7,3.9h0v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M196.9,175.6s7.2-1.9,8.2-1,1.1,3,.8,3.9c-.2.6-6.3,1.4-9,1.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M197.5,108.78c18.7-.48,48.7-12.78,48.7-12.78,0,0-11.2-40.4-12.2-43.8-1-3.4-8.6-7.2-17.3-4.4s-19.8,4.4-19.8,4.4c0,0-11.1-1.6-19.8-4.4-8.7-2.8-16.3,1-17.3,4.4-1,3.4-12.2,43.8-12.2,43.8,0,0,30,12.3,48.8,12.78v.02c.18,0,.37,0,.55-.01.18,0,.37.01.55.01v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M198.3,402.6s-18.8,9.7-21.6-10.4,1.6-84.3,1.6-84.3l18.6,21.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M87.9,155.9l38.6,66.8s-.7,6.2,2.7,20.2c3.4,13.9,10.5,14.9,10.5,14.9l35.5,80.9,4.4-93.9-20.2-5.4,15.4-52.5s-76.6-10.7-86.9-31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128.5,140.7s-40.5,6.1-39.7,13.6c.7,7.5,52.8,22,52.8,22,0,0-11.9-9.9-10.2-20.5s5.9-12.2,5.9-12.2l-8.8-3v.1Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 152.6,
    y1: 176.3,
    x2: 153.2,
    y2: 179.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171,208.4s-8.1,19.1-7.8,28.5l7.1,2.4.7-30.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M251.4,112.8l-4.4-13.1s-7.5,3.4-18.2,7c-9.78,3.17-28.51,4.78-31.95,5.06-3.44-.28-22.17-1.89-31.95-5.06-10.7-3.6-18.2-7-18.2-7l-4.4,13.1s29.26,16.96,54.55,15.74c25.29,1.22,54.55-15.74,54.55-15.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M138,155.9s1.1,12.8,8.5,16c0,0-4.8-5.4-4.9-7.7s1.8-6.2.7-7.8-1.6-4.3-1.6-4.3l-2.7,3.9h0v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M196.9,175.6s-7.2-1.9-8.2-1-1.1,3-.8,3.9c.2.6,6.3,1.4,9,1.5"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M201,164.8s2.8,6.5,1.5,8.4-2.9,2.6-2.9,2.6l6,2.3s4.5-.9,4.3-2.5-1.7-10.4-1.7-10.4l-7.1-.5h0l-.1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.2,171.5s-6.8,16.7-7.2,30.7-14.5,21.4-14.5,21.4c0,0-12.6.4-17.2-6.6-1.3-13.7,2.2-20.8,6.9-26.3l-11.2-3.8-6,17.1v34l10.2,4.9-5.5,62.2,16.3,12,9.4-49.6,2-5.1-5.2-4.3-8.2-2.1.7-21.4s8.2,8.2,12.6,6.3,6.8-5,6.8-5l2.6,5.9,8.8-3.3-1.8-31.37-3.8-21.53,19.32-5.6.88-7.7-15.9-.7h0v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M176.6,177.8s6.1-29.8,46.7-4.7c10.7,6.6,15.6,1.9,15.6,1.9l9.2-31.4s-48.8,4.7-59.9,4.4-62.1-3.8-62.1-3.8c-9.2,1.5,1.8,36.6,50.4,33.6h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M177.9,46.5s9.2,13.8,18.8,13.3,14.6-5,14.6-5c0,0-1.1,4.5-.6,6.3s7.5,13.3,7,20.1,3.6,25.9,3.6,25.9l24.8-11.3s-10.1-44.8-14.3-46.5-9.4-3.6-9.4-3.6c0,0-16.7,8-25.6,8s-18.8-7.1-18.8-7.1l-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M229,124.3s55-3.3,63.6,6.4c0,0,13-8.3,8.9-11.4s-12.8-13.3-28.6-16.7-23.3-5.6-23.3-5.6l2.5,16.9s-16.2,10.8-23.1,10.5h0v-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "221.2 108 226.1 124.8 250.9 112.6 246.7 98.7 221.2 108"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M195,328.2s-6.7,59.9-4.8,75.4-11.9,1.4-11.9,1.4c0,0-5.6-73.2-1.6-99.8l18.3,23.1h0v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M287,161.4s-10.5,27.2-14.1,34.5-19.5,22.4-19.5,32.4,5.7,10,6.2,16c.4,4.4-3.3,16.5-5.2,22.3,0,0,13.9-30.8,14.2-40.9s18.3-37.1,18.3-37.1l15.3-29.9-15.3,2.7h.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Main_Lines-4",
    "data-name": "Main Lines-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M223.5,205c-7,8.5-19.9,19.8-26.6,19.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M248.7,145.2s-3.1,16.9-11.3,35.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M248.7,147.4s6.1-4.9,9-.4c2.9,4.5,3.5,12.7.6,18.7s-14.2,21-17.7,8.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M255.7,155.4s-.3-4.9-2-4.9-5.3,6.2-4.1,9.2,2.4,4.4,1.4,6.2-4.1,3.3-4.9,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M203.6,177.8s-1.4-.5-2.8-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M248.7,95.1s54,10.9,54,25.1c0,21.9-80.1,26.7-105.8,26.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M196.9,128.9c34.4,0,55.3-15.5,55.3-15.5l-16.1-60.1c-1.6-5.2-10.7-9.8-15.3-8.7-5.4,1.4-13.2,6.8-24,6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M196.9,110.4c26.5,0,49.3-12.6,49.3-12.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M217,400.9c5.8-67.4-5-157.6-5-157.6,4.9-2.5,19.3-4.9,19.3-4.9-1-22.5-14.8-52.5-14.8-52.5,0,0,89.7-17.4,89.7-30.9s-41-14.4-41-14.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M222.8,333.6s25.9-61,37.3-76.4c11.4-15.4,8.8-31.1,10.8-36.3,1.9-5.1,35.4-65,35.4-65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M171.6,207.8s-.1,21.6-.4,31.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M196.9,256.8c6.1.1,15.2-6.7,15.2-6.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M215.4,282.3c-8.3-7.5-9.1-29.2-18.1-24.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 217,
    y1: 305.1,
    x2: 207.6,
    y2: 316.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.1,192.6s-11.8-.3-17.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196.9,187.3s3,2.2,8.1,2.5,15.7,6.1,15.7,6.1l-2.4-4.5c-10.7-4.5-13.6-9.9-21.4-7.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M170.3,205c7,8.5,19.9,19.8,26.6,19.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M145.1,145.2s3.1,16.9,11.3,35.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M145.1,147.4s-6.1-4.9-9-.4-3.5,12.7-.6,18.7,14.2,21,17.7,8.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M138,155.4s.3-4.9,2-4.9,5.3,6.2,4.1,9.2-2.4,4.4-1.4,6.2,4.1,3.3,4.9,6.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M190.2,177.8s1.4-.5,2.8-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M145.1,95.1s-54,10.9-54,25.1c0,21.9,80.1,26.7,105.8,26.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M196.9,128.9c-34.4,0-55.3-15.5-55.3-15.5l16.1-60.1c1.7-5.2,10.7-9.8,15.3-8.7,5.4,1.4,13.2,6.8,24,6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M196.9,110.4c-26.5,0-49.3-12.6-49.3-12.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M176.7,400.9c-5.8-67.4,5-157.6,5-157.6-4.9-2.5-19.3-4.9-19.3-4.9,1-22.5,14.8-52.5,14.8-52.5,0,0-89.7-17.4-89.7-30.9s41-14.4,41-14.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M171,333.6s-25.9-61-37.3-76.4c-11.4-15.4-8.8-31.1-10.8-36.3s-35.4-65-35.4-65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M222.2,207.8s.1,21.6.4,31.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M196.9,256.8c-6.1.1-15.2-6.7-15.2-6.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M178.3,282.3c8.3-7.5,9.1-29.2,18.1-24.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M205.8,272.9c.2-1.2,1.9-2.5,1.9-2.5l-2.3-8s-2,.6-2.6,1c-.53.35-4.68.39-5.61.4-1,0-5.47-.04-6.09-.4-.7-.4-2.7-1-2.7-1l-2.3,8s1.7,1.3,1.9,2.5c.2,1.2,3.2,11.8,3.2,11.8l-5.1,31.4,10.8,14.6,10.8-14.6-5.1-31.4s3-10.6,3.2-11.8Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 176.7,
    y1: 305.1,
    x2: 186.1,
    y2: 316.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.6,192.6s11.8-.3,17.2-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196.9,187.3s-3,2.2-8.1,2.5-15.7,6.1-15.7,6.1l2.4-4.5c10.7-4.5,13.6-9.9,21.4-7.3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_7-4",
    "data-name": "Layer 7-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M77,328.2s10.3-29.7,15.2-30.2,7.3,1.5,7.3,1.5c0,0-.4-4.5,1.3-7.6,1.7-3.1,10.3-4.8,10.3-4.8l3.5-29.8-4.8-11.3,9.1-22.6,4-1.2,5.2-25s7.8-2.9,12.2-.7,31.4,10.4,36.1,20.6,13.3,26.1,10.4,33.5c-2.8,7.4-23.2,59.2-23.2,59.2,0,0,4,11,2,14.8s-9.3,9.4-10,12.5,1.3,15.7-2.7,19.4-28.5,19.9-28.5,19.9c0,0-35.5-13.9-37-15.9s-10.3-32.2-10.3-32.2h0l-.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M182.1,161.1l.5-9.2-22.2-19.3-27.5,28.1s8.7,31.1,7,38.8-2.3,14.6-2.3,14.6c0,0,.7,11.5-3.2,18.8,0,0,7.9,14.9,13.7,18.2s9.3,4.7,9.3,4.7l10-34.7s13.2-15.1,13.1-18c-.1-2.9.7-18,.7-18l1.3-8.8,1.7-10.3-2.1-5h0v.1ZM155.4,156l8.4-9.5,6.6,7.6-15,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M137.7,201.6s-5.5-1.6-6.4.6-4.5,14.8,1.6,26l3.1-16.6,1.6-10h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M158.6,256.7l11.5-33.4,2.9-2.5s6.3,18.5,4.9,24.3-3.6,12.2-19.3,11.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M117.7,287.6s16.4,22.1,28.7,15.7,26.7-52.8,26.7-52.8l-.2-29.8,3.7-7.3s11.8,26.8,10.6,35-23.8,61.2-23.8,61.2c0,0,6.5,13.6,2.9,17.6s-11.9,8.7-12.1,10.5,2.1,12.5-.7,16.4-32.1,22.8-32.1,22.8l-29.4-12s31.1,3.5,35.2-7.3c4.1-10.8,9.1-28.6-9.7-70h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.2,154.8s6.2-.6,6.6,3.8c.2,2.3-.1,4.4-.1,4.4,0,0,1.1,4.5.1,5.8s-18.5,7.2-18.5,7.2l20.1-4.8s2.1,6.2-1.7,8.9-12.1,6.2-12.1,6.2c0,0,5.7,22.3,2.1,28.3s-13.4,5.1-13.4,5.1c0,0,7,4.6,6.5,8.5s-5.6,23-5.6,23l8.3,5.5,11-35.5s13.8-16.7,13.5-20.2,0-20.6,0-20.6l3.2-14.3-9.3-8.9s-2.6-5.8-10.7-2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.8,158s14.1-13.2,15.8-15.8c0,0,9.7,5.4,11.7,4.4s4.9,0,4.9,0c0,0,5.8,4.4,4.2,10.4s-1.5,4.6-1.5,4.6l-10.5-10.2-7.5-3.7-9.1,8.5-8,1.9h0v-.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hand_Lines-4",
    "data-name": "Hand Lines-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M183.2,161.8s1.2-7.1,1-9.4-23.2-21.6-23.2-21.6c-4.1.8-15.6,16.3-29,31,0,0,11.1,37.5,4.2,53.3,0,0,1.6,9.1-3,17.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M137.7,158.8s2.6.8,7.4,0,21.9-5.5,24.5-5.3,16,10.6,16,13.4-1.9,9.1-1.9,9.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M143,166.1s25.3-3.6,29.4-3,10.6,13.4,10.8,15.1-2.6,7-2.6,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M149.6,176.1c4.7.9,22.3-4.9,24.1-3.6s7.9,16.6,6.8,18.9-5.3,8.1-6.8,8.9c0,0-5.5-2.8-5.3-6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M171.9,183.1s-.8,3.4-5.2,6.4c0,0,6.2,18.5,2.6,24.9s-6.1,8.9-6.1,8.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M154.6,155.7s8.4-6.5,8.7-7.7l7.1,5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M182.5,181.2s1.8,12.5.2,20c-1.2,5.6-14.2,21.3-14.2,21.3-3.6,8.1-10.4,35.7-10.4,35.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M137.7,199.7s-8.1-2.2-9.4,6.9c-3,22.5,17,56.1,38.8,51.9,24.4-4.8,5.6-41.3,5.6-41.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M137.7,194.9s-9.4-1.4-12.3,3.2-3.8,28.1-6.6,33.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M176.7,213.5s14.6,25.8,11.4,37.4c-3.2,11.6-22.4,55.3-22.6,58.4s3.2,11.6,2.1,15.8-10,9.8-10.3,14.2-.5,16-5.5,19.8-25.5,18.7-27.4,18.7-36.3-12.8-37.7-16.7-12.5-36.5-12.5-36.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M120.2,222.1s-4.6.2-3.6,3.7,12.5,30.6,23.3,35.9l5.3,17.3-18-2s-16.7-24.2-18-30.1l7.2-22.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M104.5,337.1s-8.3-38.5-6.5-43.8,9.8-5.7,10.5-7.5,4.8-30.8,4.8-30.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M116.1,284.9s7.7,47.8,42,27.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M97,303.3s-10.6,16.6-9.7,34.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M78.4,314.9s10-22.2,18.6-17.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M127.7,261.5c4.5-4.2,11.5,4.6,7.8,10.3s-12.9-5.6-7.8-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M169.8,188.3s1.5.7,1,1.8-2,3.4-1.6,6.3"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 196.4,
    y1: 257.6,
    x2: 196.9,
    y2: 258.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalconidle);
export default __webpack_public_path__ + "static/media/falcon idle.a52ec7bef2618074cc3c609e4505f518.svg";
export { ForwardRef as ReactComponent };